export default __webpack_public_path__ + "locales/el-GR/Common.json?hash=538c88936f29c0117ce0c1b92d0708ae";